/*
 * Product media gallery keyboard control.
 *
 * Left/Right arrow keys move to the previous/next media item. Navigation is
 * delegated to the theme's own <media-gallery> element, so the thumbnail
 * highlight, the thumbnail strip scroll position, the accessibility live
 * region and video/3D playback all stay in sync.
 */
if (!window.galleryKeyboardNavigation) {
  window.galleryKeyboardNavigation = true;

  const isFormField = (element) =>
    element instanceof Element &&
    (element.isContentEditable || ['input', 'textarea', 'select'].includes(element.localName));

  // Only drive a gallery the shopper can actually see, so arrow keys stay inert
  // once the page has scrolled past it.
  const isOnScreen = (element) => {
    const rect = element.getBoundingClientRect();
    if (!rect.height) return false;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const visible = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
    return visible / Math.min(rect.height, viewportHeight) > 0.3;
  };

  const findGallery = (target) => {
    const focused = target instanceof Element ? target.closest('media-gallery') : null;
    if (focused) return focused;
    return Array.from(document.querySelectorAll('media-gallery')).find(isOnScreen);
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
    // Leave arrow keys alone inside form controls: the quantity input moves its
    // caret and the variant radio buttons navigate their group natively.
    if (isFormField(event.target)) return;

    const gallery = findGallery(event.target);
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    // Match the slide wrappers only. A plain [data-media-id] lookup also picks up
    // the lightbox button nested in every slide, which doubles the list and makes
    // the arrows land on ids the thumbnails know nothing about.
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const items = viewer ? Array.from(viewer.querySelectorAll('.product__media-item')) : [];
    if (items.length < 2) return;

    const current = items.findIndex((item) => item.classList.contains('is-active'));
    const step = event.key === 'ArrowLeft' ? -1 : 1;
    const next = (Math.max(current, 0) + step + items.length) % items.length;

    gallery.setActiveMedia(items[next].dataset.mediaId, false);
    event.preventDefault();
  });
}
